import { buildQueryFromObject } from '@ezugi/utils/helpers/buildQueryFromObject';

type TableInformation = {
  baseURL: string;
  queryParams: Record<string, any>;
  gameName: string;
  pathSegment: string;
}

export function getTableURL({ baseURL, queryParams, gameName, pathSegment }: TableInformation): string {
  const queryString = buildQueryFromObject('?', queryParams);
  const pathSection = pathSegment || `/${gameName}`;
  return `${baseURL.replace(/\/$/, '')}${pathSection}/${queryString}`;
}
